exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".finest-grid[data-v-29ef7935]{flex-wrap:nowrap;align-items:flex-start;flex-direction:column;align-content:flex-start;justify-content:center}.items[data-v-29ef7935]{font-size:30px;line-height:45px;letter-spacing:-.75px}.items span[data-v-29ef7935]{white-space:nowrap}@media only screen and (max-width:576px){.items[data-v-29ef7935]{line-height:35px;letter-spacing:-.3px;font-size:25px}.items span[data-v-29ef7935]{white-space:normal}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29ef7935","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Section.Finest.vue
// module id = 84
// module chunks = 0